import { useEffect, useState } from "react";
import { Label, Textarea } from "flowbite-react";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaFormatosGeneralesInterface } from "../../../../../interfaces/FechaFormatosGeneralesInterface";
import { FichaIdentificacionInterface } from "../../../../../interfaces/FichaIdentificacionInterface";
import { useParams } from "react-router-dom";
import { API } from "../../../../../global/global";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const FichaIdentificacionListaPrint = () => {
  const tituloFormulario = "DATOS GENERALES";
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { reset, control } = useForm();
  const [numeroHijos, setNumeroHijos] = useState(0);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);
  const { uuid } = useParams<{ uuid: string }>();

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaFG = useGetData<FechaFormatosGeneralesInterface>({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const queryFicha = useGetData<FichaIdentificacionInterface>({
    url: `/ficha_identificacion/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "ficha_identificacion"],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  useEffect(() => {
    if (queryEvaluado.data) {
      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        correo: queryEvaluado.data.correo || "",
        telefono: queryEvaluado.data.telefono || "",
        empresa_id: String(queryEvaluado.data.empresa_id.id),
        puesto: queryEvaluado.data.puesto || "",
        fecha_ingreso: queryEvaluado.data.fecha_ingreso || "",
        antiguedad: queryEvaluado.data.antiguedad || "",
        fecha_nacimiento: queryEvaluado.data.fecha_nacimiento || "",
        genero: queryEvaluado.data.genero || "",
        lugar_nacimiento: queryEvaluado.data.lugar_nacimiento || "",
        nacionalidad: queryEvaluado.data.nacionalidad || "",
        curp: queryEvaluado.data.curp || "",
        rfc: queryEvaluado.data.rfc || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        calle: queryEvaluado.data.calle || "",
        numero_exterior: queryEvaluado.data.numero_exterior || "",
        numero_interior: queryEvaluado.data.numero_interior || "",
        referencia: queryEvaluado.data.referencia || "",
        colonia: queryEvaluado.data.colonia || "",
        codigo_postal: queryEvaluado.data.codigo_postal || "",
        municipio: queryEvaluado.data.municipio || "",
        estado: queryEvaluado.data.estado || "",
        pais: queryEvaluado.data.pais || "",
        anios_domicilio_viviendo:
          queryEvaluado.data.anios_domicilio_viviendo || "",
        personas_vivienda: queryEvaluado.data.personas_vivienda || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        vive_con: queryEvaluado.data.vive_con || "",
        tiempo_casado: queryEvaluado.data.tiempo_casado || "",
        nombre_conyuge: queryEvaluado.data.nombre_conyuge || "",
        conyuge_oficio: queryEvaluado.data.conyuge_oficio || "",
        cuantos_hijos: queryEvaluado.data.cuantos_hijos || "",
        nombre_hijo1: queryEvaluado.data.nombre_hijo1 || "",
        edad_hijo1: queryEvaluado.data.edad_hijo1 || "",
        nombre_hijo2: queryEvaluado.data.nombre_hijo2 || "",
        edad_hijo2: queryEvaluado.data.edad_hijo2 || "",
        nombre_hijo3: queryEvaluado.data.nombre_hijo3 || "",
        edad_hijo3: queryEvaluado.data.edad_hijo3 || "",
        nombre_hijo4: queryEvaluado.data.nombre_hijo4 || "",
        edad_hijo4: queryEvaluado.data.edad_hijo4 || "",
        nombre_hijo5: queryEvaluado.data.nombre_hijo5 || "",
        telefono_recados: queryEvaluado.data.telefono_recados || "",
        empresa_labora: queryEvaluado.data.empresa_labora || "",
      });

      setNumeroHijos(Number(queryEvaluado.data.cuantos_hijos) || 0);
    }
  }, [queryEvaluado.data, reset, uuid]);

  useEffect(() => {
    if (queryFechaFG.data) {
      const fechafg = queryFechaFG.data;
      reset({
        fecha_ficha_ident: fechafg.fecha_ficha_ident || "",
      });
    }
  }, [queryFechaFG.data, reset]);

  useEffect(() => {
    if (queryFicha.data) {
      const fichafg = queryFicha.data;
      reset({
        cicatrices: fichafg.cicatrices || "",
        lunares: fichafg.lunares || "",
        defecto_fisico: fichafg.defecto_fisico || "",
        tatuajes: fichafg.tatuajes || "",
        perdida_miembro: fichafg.perdida_miembro || "",
        deteccion_riesgo_ficha: fichafg.deteccion_riesgo_ficha || "",
      });
    }
  }, [queryFicha.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  return (
    <div className="max-w-[800px] mx-auto p-4 bg-white">
      {/* Marca de agua */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-1 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>

      {/* Table section */}
      <div className="border-2 border-slate-700 mt-4">
        <table className="w-full text-sm">
          <tbody>
            <tr>
              <td className="border-r-2 border-b-2 border-slate-700 p-2">
                <div className="font-semibold">
                  FECHA DE EVALUACION:
                  <Label
                    id="fecha"
                    value={
                      queryFechaFG.data?.fecha_ficha_ident
                        ? (() => {
                            const date = new Date(
                              queryFechaFG.data.fecha_ficha_ident
                            );
                            date.setDate(date.getDate() + 1);
                            return date.toLocaleDateString("es-ES", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            });
                          })()
                        : "Fecha no disponible"
                    }
                    disabled
                    className="ml-2"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="border-r-2 border-b-2 border-slate-700 p-2">
                <div className="font-semibold flex items-start">
                  EMPRESA A LA QUE SE POSTULA Y EMPRESA PARA LA QUE LABORA:
                  <Label
                    id="empresa"
                    value={`${queryEvaluado.data?.empresa_id?.nombre || ""} ${
                      queryEvaluado.data?.empresa_labora
                        ? "y " + queryEvaluado.data.empresa_labora
                        : ""
                    }`}
                    disabled
                    className="ml-2"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="border-r-2 border-b-2 border-slate-700 p-2">
                <div className="font-semibold">
                  ¿SE POSTULA O EVALÚA?
                  <Label
                    id="nombre_hijo5"
                    value={`${queryEvaluado.data?.nombre_hijo5 || ""} `}
                    disabled
                    className="ml-2"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="border-r-2 border-b-2 border-slate-700 p-2">
                <div className="font-semibold">
                  PUESTO:
                  <Label
                    id="empresa"
                    value={`${queryEvaluado.data?.puesto || ""}`}
                    disabled
                    className="ml-2"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="border-r-2 border-b-2 border-slate-700 p-2">
                <div className="font-semibold">
                  FECHA DE INGRESO Y ANTIGÜEDAD:
                  <Label
                    id="empresa"
                    value={`Ingresó el ${
                      queryEvaluado.data?.fecha_ingreso || ""
                    } y tiene ${
                      queryEvaluado.data?.antiguedad || ""
                    } años de antigüedad`}
                    disabled
                    className="ml-2"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Main Form */}
      <div className="border-2 border-slate-700 mb-4">
        <div className="bg-cyan-300 text-center py-2 font-semibold border-b-2 border-slate-700">
          DATOS GENERALES
        </div>

        <div className="grid grid-cols-3 gap-4 p-2">
          <div className="col-span-2">
            {/* Left side form fields - Updated style */}
            <div>
              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  NOMBRE COMPLETO
                </div>
                <Label
                  id="nombre"
                  value={`${queryEvaluado.data?.nombre || ""} ${
                    queryEvaluado.data?.apellido_paterno || ""
                  } ${queryEvaluado.data?.apellido_materno || ""}`}
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>

              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  FECHA DE NACIMIENTO
                </div>
                <Label
                  id="empresa"
                  value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>

              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  LUGAR DE NACIMIENTO
                </div>
                <Label
                  id="empresa"
                  value={`${queryEvaluado.data?.lugar_nacimiento || ""}`}
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>

              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  NACIONALIDAD
                </div>
                <Label
                  id="empresa"
                  value={`${queryEvaluado.data?.nacionalidad || ""}`}
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>

              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  CURP
                </div>
                <Label
                  id="empresa"
                  value={`${queryEvaluado.data?.curp || ""}`}
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>

              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  ÚLTIMO GRADO DE ESTUDIOS
                </div>
                <Label
                  id="empresa"
                  value={`${queryEvaluado.data?.escolaridad || ""}`}
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>

              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  CIUDAD DEL DOMICILIO DONDE VIVE
                </div>
                <Label
                  id="empresa"
                  value={`${queryEvaluado.data?.estado || ""}`}
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>

              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  CON QUIEN VIVE
                </div>
                <Label
                  id="empresa"
                  value={`${queryEvaluado.data?.vive_con || ""}`}
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>

              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  CORREO ELECTRÓNICO
                </div>
                <Label
                  id="empresa"
                  value={`${queryEvaluado.data?.correo || ""}`}
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>
            </div>
          </div>

          {/* Right side - Photo section and additional fields */}
          <div className="mt-4">
            <div className="border-2 border-slate-700 h-48 flex items-center justify-center">
              {photoUrl ? (
                <img
                  src={photoUrl}
                  alt="Foto de evaluado"
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-gray-500">Sin foto disponible</span>
              )}
            </div>
            <div className="border border-slate-300">
              <div className="text-center border-b border-slate-300 py-1 text-sm">
                RFC
              </div>
              <Label
                id="empresa"
                value={`${queryEvaluado.data?.rfc || ""}`}
                disabled
                className="w-full p-2 text-red text-center"
              />
            </div>

            <div className="border border-slate-300">
              <div className="text-center border-b border-slate-300 py-1 text-xs">
                DOMICILIO PARTICULAR
              </div>
              <Label
                id="empresa"
                value={`${queryEvaluado.data?.calle || ""}, ${
                  queryEvaluado.data?.numero_exterior || ""
                }, ${queryEvaluado.data?.numero_interior || ""}, ${
                  queryEvaluado.data?.colonia || ""
                }, ${queryEvaluado.data?.codigo_postal || ""}, ${
                  queryEvaluado.data?.municipio || ""
                }, ${queryEvaluado.data?.estado || ""}, ${
                  queryEvaluado.data?.pais || ""
                }`}
                disabled
                className="w-full p-2 text-red text-center text-xs"
              />
            </div>

            <div className="border border-slate-300">
              <div className="text-center border-b border-slate-300 py-1 text-sm">
                CUANTOS AÑOS TIENE VIVIENDO EN ESE DOMICILIO
              </div>
              <textarea
                id="empresa"
                rows={7}
                disabled
                className="w-full p-2 text-black-500 text-justify bg-transparent border-none resize-none"
                value={`${
                  queryEvaluado.data?.anios_domicilio_viviendo || ""
                } años`}
                readOnly
              />
            </div>
          </div>
        </div>
      </div>
      <div className="relative">
        {/* Header */}
        <HeaderPrint titulo={tituloFormulario} />
        {/* Título del formulario */}
        <div id="headerContent" className="text-center">
          <h1
            className="text-black text-xl font-bold py-1 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
            style={{
              backgroundImage: `url(${fotoMapa})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {tituloFormulario}
          </h1>
        </div>
        {/* Marca de agua */}
        <div className="absolute inset-0 top-[60%] flex justify-center items-center pointer-events-none z-0">
          <div
            className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
            style={{ opacity: 0.1 }}
          >
            CONFIDENCIAL
          </div>
        </div>
        {/* Segunda tabla */}
        <div className="border-2 border-slate-700 mt-4">
          <div className="grid grid-cols-3 gap-4 p-2">
            <div className="col-span-2">
              {/* Left side form fields - Updated style */}
              <div>
                <div className="border border-slate-300">
                  <div className="text-center border-b border-slate-300 py-1 text-sm">
                    TIEMPO DE CASADO Y/O CONCUBINATO
                  </div>
                  <Label
                    id="empresa"
                    value={`${queryEvaluado.data?.tiempo_casado || ""} años`}
                    disabled
                    className="w-full p-2 text-red text-center"
                  />
                </div>
                <div className="border border-slate-300">
                  <div className="text-center border-b border-slate-300 py-1 text-sm">
                    NOMBRE DE ESPOSA(O) Y/O CONCUBINO
                  </div>
                  <Label
                    id="empresa"
                    value={`${queryEvaluado.data?.nombre_conyuge || ""}`}
                    disabled
                    className="w-full p-2 text-red text-center"
                  />
                </div>
                <div className="border border-slate-300">
                  <div className="text-center border-b border-slate-300 py-1 text-sm">
                    NOMBRE Y EDADES DE LOS HIJOS
                  </div>
                  <Label
                    id="empresa"
                    value={Array.from({ length: numeroHijos }, (_, index) => {
                      const nombreKey = `nombre_hijo${
                        index + 1
                      }` as keyof EvaluadoInterface;
                      const edadKey = `edad_hijo${
                        index + 1
                      }` as keyof EvaluadoInterface;
                      const nombre = queryEvaluado.data?.[nombreKey] || "";
                      const edad = queryEvaluado.data?.[edadKey] || "";
                      return `${nombre}${
                        nombre && edad ? `, ${edad} años` : ""
                      }`;
                    }).join(", ")}
                    disabled
                    className="w-full p-2 text-red text-center"
                  />
                </div>
                <div className="border border-slate-300">
                  <div className="text-center border-b border-slate-300 py-1 text-sm">
                    CICATRICES, LUNARES:
                  </div>
                  <Label
                    id="empresa"
                    value={`${queryFicha.data?.cicatrices} Cicatrices y ${queryFicha.data?.lunares} Lunares`}
                    disabled
                    className="w-full p-2 text-red text-center"
                  />
                </div>
                <div className="border border-slate-300">
                  <div className="text-center border-b border-slate-300 py-1 text-sm">
                    ALGÚN DEFECTO FÍSICO:
                  </div>
                  <Label
                    id="empresa"
                    value={`${queryFicha.data?.defecto_fisico}`}
                    disabled
                    className="w-full p-2 text-red text-center"
                  />
                </div>
                <div className="border border-slate-300">
                  <div className="text-center border-b border-slate-300 py-1 text-sm">
                    TATUAJES:
                  </div>
                  <Label
                    id="empresa"
                    value={`${queryFicha.data?.tatuajes} Tatuajes`}
                    disabled
                    className="w-full p-2 text-red text-center"
                  />
                </div>
                <div className="border border-slate-300">
                  <div className="text-center border-b border-slate-300 py-1 text-sm">
                    PERDIDA DE ALGÚN MIEMBRO:
                  </div>
                  <Label
                    id="empresa"
                    value={`${queryFicha.data?.perdida_miembro}`}
                    disabled
                    className="w-full p-2 text-red text-center"
                  />
                </div>
                {/* Recuadro para huella digital */}
                <div className="border-2 border-slate-700 mt-4 h-32 flex flex-col items-center justify-center">
                  <div className="text-center text-sm font-semibold mb-2">
                    HUELLA DIGITAL
                  </div>
                </div>
              </div>
            </div>
            {/* Right side - Photo section and additional fields */}
            <div>
              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  TELEFONO Y TELEFONO PARA RECADOS
                </div>
                <textarea
                  id="empresa"
                  value={`(${
                    queryEvaluado.data?.telefono || ""
                  })                    (${
                    queryEvaluado.data?.telefono_recados || ""
                  })`}
                  rows={5}
                  disabled
                  className="w-full p-2 text-black-500 text-justify bg-transparent border-none resize-none"
                />
              </div>

              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  ESTADO CIVIL
                </div>
                <Label
                  id="empresa"
                  value={
                    queryEvaluado.data?.estado_civil
                      ? queryEvaluado.data.estado_civil
                          .charAt(0)
                          .toUpperCase() +
                        queryEvaluado.data.estado_civil.slice(1).toLowerCase()
                      : ""
                  }
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>
              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  A QUE SE DEDICA SU ESPOSA(O) Y/O CONCUBINO
                </div>
                <Label
                  id="empresa"
                  value={`${queryEvaluado.data?.conyuge_oficio || ""}`}
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>
              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  CUANTOS HIJOS TIENE
                </div>
                <Label
                  id="empresa"
                  value={`${queryEvaluado.data?.cuantos_hijos || ""} hijos`}
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>
              <div className="border border-slate-300">
                <div className="text-center border-b border-slate-300 py-1 text-sm">
                  DETECCIÓN DE RIESGO:
                </div>
                <Label
                  id="empresa"
                  value={`${queryFicha.data?.deteccion_riesgo_ficha}`}
                  disabled
                  className="w-full p-2 text-red text-center"
                />
              </div>
              {/* Recuadro para huella digital */}
              <div className="border-2 border-slate-700 mt-4 h-32 flex flex-col items-center justify-center">
                <div className="text-center text-sm font-semibold mb-2">
                  HUELLA DIGITAL
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
